
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Group_49127","data-name":"Group 49127","xmlns":"http://www.w3.org/2000/svg","width":"25","height":"25"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"clip-path"}},[_c('rect',{attrs:{"id":"Rectangle_16711","data-name":"Rectangle 16711","width":"25","height":"25","fill":"none"}})])]),_c('g',{attrs:{"id":"Group_49128","data-name":"Group 49128"}},[_c('g',{attrs:{"id":"Group_49127-2","data-name":"Group 49127","clip-path":"url(#clip-path)"}},[_c('path',{attrs:{"id":"Path_38425","data-name":"Path 38425","d":"M9.256 16.076c3.362-2.647 5.183-4.2 5.183-5.812a1.746 1.746 0 00-1.947-1.709 3.12 3.12 0 00-2.535 1.176l-.715-.743a4.05 4.05 0 013.25-1.471c1.555 0 3.138.883 3.138 2.747 0 1.9-1.933 3.641-4.539 5.7h4.581V17H9.256z","fill":"#5858ec"}})])]),_c('g',{attrs:{"id":"Group_49130","data-name":"Group 49130"}},[_c('g',{attrs:{"id":"Group_49135","data-name":"Group 49135"}},[_c('path',{attrs:{"id":"Path_38426","data-name":"Path 38426","d":"M25 20.313V4.688A4.692 4.692 0 0020.313 0H4.688A4.693 4.693 0 000 4.688v15.625A4.692 4.692 0 004.688 25h15.625A4.693 4.693 0 0025 20.313M20.313 1.042a3.649 3.649 0 013.646 3.646v15.625a3.649 3.649 0 01-3.646 3.646H4.688a3.649 3.649 0 01-3.646-3.646V4.688a3.649 3.649 0 013.646-3.646z","fill":"#5858ec"}})])])])
          )
        }
      }
    